export default __webpack_public_path__ + "static/media/BGMusic.5d65adeb.mp3";